
/* ============================== src/utils/helpContent.jsx ============================== */
export const HELP_SECTIONS = [
  {
    id: "overview",
    label: "О системе",
    content: (
      <>
        <h3>АвиаГоризонт</h3>
        <p>
          Корпоративная система планирования и учёта рабочего времени
          инженерного центра. Сводит в одном месте задачи, проекты,
          производственный календарь, персонал и отчётность.
        </p>

        <h4>Основные сущности</h4>
        <ul>
          <li>
            <b>Задача</b> - единица работы с планом часов, сроком, исполнителем
            и статусом. Может иметь подзадачи любой глубины и зависимости от
            других задач.
          </li>
          <li>
            <b>Проект</b> - контейнер задач, объединённых общей целью,
            заказчиком и планом часов. Бывает производственным (с договором и
            ставкой) или административным (внутренние мероприятия предприятия).
          </li>
          <li>
            <b>Сотрудник</b> - учётная запись с ролями, подразделениями и
            эффективной ставкой. Роли определяют доступ к действиям и разделам.
          </li>
          <li>
            <b>Подразделение</b> - отдел или конструкторское бюро (КБ).
            Сотрудник может числиться в нескольких, одно из которых - основное.
          </li>
          <li>
            <b>Роль</b> - набор прав: администратор, директор, главный
            конструктор, руководитель отдела, ответственный по проекту, менеджер
            проектов, экономист, бухгалтер, HR, исполнитель.
          </li>
          <li>
            <b>Метка (тег)</b> - короткий текстовый ярлык задачи или проекта.
            Вводится в поле «Метки». Нажатие на ярлык открывает список задач и
            проектов с этой меткой.
          </li>
          <li>
            <b>Замещение</b> - временная передача ролей и/или задач коллеге на
            период отсутствия (отпуск, командировка, больничный, ротация).
          </li>
          <li>
            <b>Производственный календарь</b> - праздники и сокращённые дни
            года. Влияет на расчёт нормы рабочего времени, ёмкости сотрудников и
            напоминаний о часах.
          </li>
        </ul>

        <h4>Связанные разделы</h4>
        <p>
          «Вход и регистрация», «Навигация», «Роли и права», «Задачи»,
          «Проекты», «Метки».
        </p>
      </>
    ),
  },
  {
    id: "glossary",
    label: "Глоссарий",
    content: (
      <>
        <h3>Глоссарий</h3>
        <ul>
          <li>
            <b>Задача</b> - единица работы с планом часов, сроком, исполнителем
            и статусом.
          </li>
          <li>
            <b>Подзадача</b> - задача внутри другой задачи, с той же структурой
            полей.
          </li>
          <li>
            <b>Суммарная задача</b> - задача с подзадачами; её план ≥ суммы
            планов потомков.
          </li>
          <li>
            <b>Часовая задача</b> - задача с фиксированным временем начала и
            окончания в один день.
          </li>
          <li>
            <b>Зависимость</b> - связь задач типа FS / SS / FF.
          </li>
          <li>
            <b>План / Факт / Остаток</b> - плановые часы задачи, введённые часы,
            разница.
          </li>
          <li>
            <b>Ёмкость</b> - доступное сотруднику количество часов за период с
            учётом ставки и календаря.
          </li>
          <li>
            <b>Эффективная ставка</b> - доля полной ставки; 1 для основного
            подразделения, сумма ставок для совмещений.
          </li>
          <li>
            <b>Метка (тег)</b> - короткий текстовый ярлык задачи или проекта.
            Единый массив <code>tags</code> собирается из поля «Метки».
          </li>
          <li>
            <b>Замещение</b> - временная передача ролей и/или задач коллеге.
          </li>
          <li>
            <b>Делегирование</b> - передача ролей без привязки к периоду
            отсутствия.
          </li>
          <li>
            <b>Согласование назначения</b> - решение руководителя исполнителя о
            назначении задачи или проекта.
          </li>
          <li>
            <b>Черновик</b> - сущность в статусе <code>draft</code>. В рабочих
            списках не отображается; видна автору в разделе «Черновики» и
            согласующему - после отправки на согласование.
          </li>
          <li>
            <b>Архив</b> - закрытые и отменённые сущности, доступны только для
            чтения.
          </li>
          <li>
            <b>НЗП</b> - незавершённое производство, часы по незакрытым задачам
            проекта за период.
          </li>
          <li>
            <b>КБ</b> - конструкторское бюро.
          </li>
          <li>
            <b>ГК</b> - главный конструктор.
          </li>
          <li>
            <b>РО</b> - руководитель отдела.
          </li>
          <li>
            <b>ОП</b> - ответственный по проекту.
          </li>
          <li>
            <b>МП</b> - менеджер проектов.
          </li>
          <li>
            <b>СУП</b> - суперадминистратор.
          </li>
          <li>
            <b>ГД</b> - генеральный директор.
          </li>
          <li>
            <b>ГЭ</b> - главный экономист.
          </li>
          <li>
            <b>БУХ</b> - бухгалтер.
          </li>
          <li>
            <b>HR</b> - HR-менеджер.
          </li>
          <li>
            <b>ИСП</b> - исполнитель (производная роль).
          </li>
        </ul>

        <h4>Типы зависимостей</h4>
        <ul>
          <li>
            <b>FS</b> (Finish-to-Start, «Окончание - Начало») - задача-
            последователь начинается на следующий день после окончания
            задачи-предшественника. Формула:{" "}
            <code>B.start = A.deadline + 1</code>.
          </li>
          <li>
            <b>SS</b> (Start-to-Start, «Начало - Начало») - задача-
            последователь начинается одновременно с началом предшественника.
            Формула: <code>B.start = A.start</code>.
          </li>
          <li>
            <b>FF</b> (Finish-to-Finish, «Окончание - Окончание») -
            задача-последователь заканчивается одновременно с окончанием
            предшественника. Формула: <code>B.deadline = A.deadline</code>.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "auth",
    label: "Вход и регистрация",
    content: (
      <>
        <h3>Вход в систему</h3>
        <p>
          На экране входа - поля «Логин» и «Пароль». <b>Логин</b> - часть e-mail
          до знака <code>@</code>, например для{" "}
          <code>ivan.konstruktorov@volga-dnepr.com</code> имя пользователя -{" "}
          <code>ivan.konstruktorov</code>. Полный e-mail тоже принимается
          (например, <code>ivan.konstruktorov@volga-dnepr.com</code>).
          Допустимые домены: <code>@volga-dnepr.com</code>,{" "}
          <code>@airbridgecargo.com</code>.
        </p>
        <ul>
          <li>
            Поле пароля - с кнопкой «глаз»: нажатие показывает пароль, через 10
            секунд он скрывается автоматически. Повторное нажатие скрывает
            сразу.
          </li>
          <li>
            Если полный e-mail не проходит проверку по формату или домену, под
            полем появляется подсказка, а форма коротко «встряхивается».
          </li>
          <li>
            <b>Блокировка после 5 неудачных попыток</b> - на 15 минут. В
            сообщении показывается, сколько минут осталось.
          </li>
          <li>
            Если локальная часть e-mail совпадает у нескольких сотрудников
            (разные домены), вход по имени пользователя без <code>@</code>{" "}
            блокируется с сообщением «Имя пользователя неоднозначно…».
            Используйте полный e-mail.
          </li>
        </ul>

        <h4>Регистрация</h4>
        <p>
          По кнопке «Регистрация» открывается форма: имя, фамилия, e-mail,
          пароль, подтверждение. Требования к паролю:
        </p>
        <ul>
          <li>минимум 8 символов;</li>
          <li>заглавная буква;</li>
          <li>строчная буква;</li>
          <li>цифра;</li>
          <li>специальный символ.</li>
        </ul>
        <p>
          Соблюдение требований видно по галочкам под полем. После успешной
          регистрации пользователь автоматически входит с ролью «Исполнитель», а
          суперадминистратор получает уведомление о новой заявке на регистрацию.
        </p>
        <p>
          Проверка дублей: e-mail не должен совпадать ни с существующим
          сотрудником, ни с уже поданной заявкой на регистрацию. Кроме того,{" "}
          <b>локальная часть e-mail (имя пользователя) не должна быть занята</b>{" "}
          - иначе вход по этому имени стал бы неоднозначным ещё до первого
          входа.
        </p>

        <h4>Восстановление пароля</h4>
        <p>
          Ссылка «Забыли пароль?» - вводится e-mail, проверяется формат и
          наличие в системе, после чего показывается заглушка «Ссылка
          отправлена» (в демонстрационном режиме реальное письмо не уходит).
        </p>

        <h4>Особые случаи</h4>
        <ul>
          <li>Уволенный сотрудник войти не может.</li>
          <li>Заблокированный - видит сообщение с оставшимся временем.</li>
          <li>После успешного входа счётчик неудачных попыток сбрасывается.</li>
          <li>
            Если локальная часть e-mail совпадает у нескольких сотрудников, вход
            по имени пользователя без <code>@</code> отклоняется с сообщением
            «Имя пользователя неоднозначно. Уточните полный e-mail с доменом.».
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "navigation",
    label: "Навигация",
    content: (
      <>
        <h3>Навигация по системе</h3>
        <p>
          Слева - постоянная боковая панель со списком разделов, сверху - панель
          инструментов, внизу боковой панели - карточка пользователя.
        </p>

        <h4>Разделы боковой панели</h4>
        <ul>
          <li>
            <b>Задачи</b> - доска задач и список задач.
          </li>
          <li>
            <b>Шаблоны и черновики</b> - общий раздел с двумя вкладками:
            «Шаблоны» и «Черновики» (см. статью «Шаблоны и черновики»).
          </li>
          <li>
            <b>Проекты</b> - доска задач и список проектов.
          </li>
          <li>
            <b>Календарь</b> - задачи по дням.
          </li>
          <li>
            <b>Диаграмма Ганта</b> - временная диаграмма задач.
          </li>
          <li>
            <b>Персонал</b> - сотрудники и их загрузка.
          </li>
          <li>
            <b>Отчёты</b> - аналитика по задачам, проектам, сотрудникам,
            трудозатратам, НЗП. Пункт виден только ролям администратора,
            генерального директора, главного экономиста, бухгалтера, главного
            конструктора КБ, руководителя отдела, ответственного по проекту,
            HR-менеджера.
          </li>
          <li>
            <b>Архив</b> - закрытые и отменённые сущности.
          </li>
          <li>
            <b>Запросы и заявки</b> - согласования, изменения, регистрации.
          </li>
          <li>
            <b>Журнал аудита</b> - история значимых действий (только admin и
            director).
          </li>
        </ul>

        <h4>Верхняя панель</h4>
        <ul>
          <li>
            <b>Сотрудники в отпусках</b> - быстрый список тех, кто отсутствует
            сегодня.
          </li>
          <li>
            <b>Производственный календарь</b> - просмотр праздников и
            сокращённых дней.
          </li>
          <li>
            <b>Переключатель темы</b> - светлая / тёмная.
          </li>
          <li>
            <b>Колокольчик</b> - уведомления; нажатие на уведомление открывает
            нужную сущность или раздел.
          </li>
          <li>
            <b>Справка</b> - это окно.
          </li>
        </ul>

        <h4>Карточка пользователя</h4>
        <p>
          ФИО, список ролей, значок активного замещения («замещает Иванова до
          25.10.2026»). Нажатие на карточку открывает личный кабинет, кнопка
          справа - выход из системы.
        </p>

        <h4>URL-адреса</h4>
        <p>
          Маршруты хранятся в hash - можно делиться ссылками и пользоваться
          кнопками браузера:
        </p>
        <ul>
          <li>
            <code>#/view/tasks</code> - раздел «Задачи».
          </li>
          <li>
            <code>#/task/t01/form</code> - карточка задачи на вкладке «Данные».
          </li>
          <li>
            <code>#/task/t01/chat</code> - на вкладке «Обсуждение».
          </li>
          <li>
            <code>#/project/p_lm24/info</code> - карточка проекта.
          </li>
          <li>
            <code>#/file/&lt;id&gt;</code>, <code>#/folder/&lt;id&gt;</code> -
            файл или папка.
          </li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Если открыть ссылку на сущность, к которой нет доступа, показывается
            всплывающее уведомление «Доступ запрещён», а пользователь
            возвращается в текущий раздел.
          </li>
          <li>
            Разделы «Журнал аудита» и «Отчёты» видны не всем - это зависит от
            ролей.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "search",
    label: "Поиск и фильтрация",
    content: (
      <>
        <h3>Поиск и фильтрация</h3>
        <p>
          Поиск и фильтры есть в каждом разделе: задачи, проекты, персонал,
          отчёты, журнал, файлы, обсуждения. Правила везде одинаковые.
        </p>

        <h4>Как работает поиск</h4>
        <ul>
          <li>Поиск - по подстроке, регистронезависимый.</li>
          <li>
            В разделах «Задачи» и «Проекты» отдельного поиска нет - подстрочный
            поиск встроен в выпадающие списки «Задача» и «Проект» (ищет по
            названию и коду проекта).
          </li>
          <li>В персонале - по ФИО, должности, отделу.</li>
          <li>В журнале - по действию и деталям.</li>
          <li>В файлах - по имени файла.</li>
          <li>
            В обсуждениях - по тексту комментария с навигацией по совпадениям.
          </li>
        </ul>

        <h4>Фильтры: «все / любое / вне»</h4>
        <ul>
          <li>
            <b>Все</b> - не фильтровать по этому полю.
          </li>
          <li>
            <b>Любое</b> (для КБ и отделов) - только те, у кого есть хотя бы
            одно подразделение этого типа.
          </li>
          <li>
            <b>Вне</b> - только те, у кого нет ни одного подразделения этого
            типа.
          </li>
        </ul>

        <h4>Специфика по разделам</h4>
        <ul>
          <li>
            <b>Задачи</b> - фильтр «Срок до»: показывает задачи со сроком не
            позже указанной даты. Если поле пустое - фильтр не активен.
          </li>
          <li>
            <b>Проекты</b> - фильтр «Окончание до»: аналогично по дате окончания
            проекта.
          </li>
          <li>
            <b>Персонал</b> - фильтр «Отдел»: «Вне отделов» показывает
            директора, главного бухгалтера, руководителей без отдела.
          </li>
          <li>
            <b>Отчёты</b> - фильтры сохраняются как шаблоны в localStorage.
          </li>
          <li>
            <b>Журнал</b> - группировка по месяцам и дням, пагинация по 20
            записей.
          </li>
        </ul>

        <h4>Сортировка</h4>
        <ul>
          <li>
            Выпадающий список поля и кнопка направления «лестница» показывают
            активное поле и направление.
          </li>
          <li>
            Пустые значения (нет срока, нет исполнителя) - всегда в конце,
            независимо от направления.
          </li>
          <li>
            В задачах: приоритет, срок, название, исполнитель, проект, план,
            факт.
          </li>
          <li>
            В проектах: приоритет, даты, название, код, статус, план,
            ответственный.
          </li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Фильтры не сбрасываются при переключении между режимами внутри
            одного раздела (например, доска задач ↔ список в разделе «Задачи»).
          </li>
          <li>Фильтры сбрасываются при переходе в другой раздел.</li>
          <li>
            Переключатели «Все задачи» / «Все проекты» в футере раздела.
            Выключены - показываются только сущности, назначенные на вас.
          </li>
        </ul>

        <h4>Связанные разделы</h4>
        <p>
          «Задачи», «Проекты», «Персонал», «Отчёты», «Журнал аудита», «Файлы и
          вложения», «Обсуждения».
        </p>
      </>
    ),
  },
  {
    id: "tasks",
    label: "Задачи",
    content: (
      <>
        <h3>Раздел «Задачи»</h3>
        <p>
          Два режима отображения одной базы задач. Переключение - сегментом в
          футере раздела.
        </p>

        <h4>Режимы отображения</h4>
        <ul>
          <li>
            <b>Доска задач</b> - карточки по статусам. Перетаскивание карточки
            между колонками меняет статус задачи (при наличии прав).
          </li>
          <li>
            <b>Список</b> - карточки с прогрессом часов, аватарами и значком
            непрочитанных сообщений. Раскладка переключается между «Плиткой» и
            «Полосой».
          </li>
        </ul>
        <p>
          Диаграмма Ганта и Календарь - отдельные разделы (см. соответствующие
          статьи справки).
        </p>

        <h4>Фильтры и сортировка</h4>
        <ul>
          <li>Задача - выпадающий список с поиском по названию.</li>
          <li>
            Проект - только проекты, доступные вашей роли и подразделениям.
          </li>
          <li>
            Исполнитель - только те, у кого есть задачи в текущей выборке.
          </li>
          <li>Приоритет - Низкий / Средний / Высокий / Критический.</li>
          <li>
            Отдел - фильтр по подразделению исполнителя (скрыт, если у вас
            единственная роль - «Исполнитель»).
          </li>
          <li>
            <b>Метка</b> - фильтр по метке из числа тех, что встречаются у задач
            в текущей выборке. Пустое значение «Метка» = все задачи, в том числе
            без меток.
          </li>
          <li>«Срок до» - поле даты. Пустое поле не фильтрует.</li>
          <li>
            Сортировка: по приоритету, сроку, названию, исполнителю, проекту,
            плановым или фактическим часам.
          </li>
        </ul>

        <h4>Ярлыки меток на карточках</h4>
        <p>
          Если у задачи есть метки, они показываются под её названием. Нажатие
          на ярлык открывает список всех задач и проектов с этой меткой.
          Подробнее см. раздел «Метки».
        </p>

        <h4>Пример сценария</h4>
        <ol>
          <li>Откройте «Задачи» → «Список».</li>
          <li>В фильтре «Проект» выберите «ЛМ-24».</li>
          <li>В фильтре «Исполнитель» выберите «Исаев Роман».</li>
          <li>
            Нажатие на карточку задачи «Расчёт подъёмной силы крыла» - открылась
            карточка.
          </li>
        </ol>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Черновики задач на доске задач и в списке не показываются - они в
            разделе «Черновики».
          </li>
          <li>
            Закрытые и отменённые задачи попадают в «Архив» сразу и три месяца с
            даты закрытия находятся на доске задач и в списке в статусе
            «Закрыта» или «Отменена». Если проект закрыт, то задачи попадают в
            Архив сразу и на доске задач / в списке не отображаются.
          </li>
          <li>Задачи без срока исполнения не видны в разделе «Календарь».</li>
        </ul>

        <h4>Связанные разделы</h4>
        <p>
          «Карточка задачи», «Метки», «Зависимости задач», «Бюджеты и планы»,
          «Архив», «Календарь», «Диаграмма Ганта».
        </p>
      </>
    ),
  },
  {
    id: "tags",
    label: "Метки",
    content: (
      <>
        <h3>Метки (теги)</h3>
        <p>
          Метка - короткий текстовый ярлык задачи или проекта. У одной сущности
          может быть до 10 меток, длина каждой - до 32 символов.
        </p>

        <h4>Ввод</h4>
        <p>
          Метки вводятся в поле «Метки» в карточке - под «Описанием».
          Разделители - запятая и пробел: <code>bug, срочно, релиз</code> или{" "}
          <code>bug срочно релиз</code>. Дополнительных источников меток нет.
        </p>

        <h4>Нормализация</h4>
        <p>
          Все метки приводятся к нижнему регистру, у них обрезаются пробелы.
          Дубликаты удаляются.
        </p>

        <h4>Отображение</h4>
        <ul>
          <li>В карточке (просмотр) - ярлыки под описанием.</li>
          <li>
            На карточках задач и проектов в списках и на доске задач - под
            заголовком, над приоритетом.
          </li>
          <li>
            В режиме редактирования ярлыки не показываются: сначала сохранение,
            потом просмотр.
          </li>
        </ul>

        <h4>Нажатие на ярлык</h4>
        <p>
          Открывает окно с двумя секциями: «Задачи (N)» и «Проекты (M)». В
          каждой - сущности, у которых есть эта метка. Список строится только из
          видимых сущностей: метка не даёт доступа к чужим задачам и проектам.
          Нажатие по строке открывает карточку; после закрытия пользователь
          возвращается в тот же список.
        </p>

        <h4>Фильтр по метке</h4>
        <p>
          В панели фильтров разделов «Задачи» и «Проекты» - выпадающий список
          «Метка». Значения собираются из меток, которые встречаются у сущностей
          в текущей выборке.
        </p>

        <h4>Метки в шаблонах</h4>
        <p>
          Шаблоны задач и проектов хранят метки. При сохранении карточки как
          шаблона метки включаются в данные шаблона, а при применении шаблона к
          новой задаче или новому проекту автоматически подставляются в поле
          «Метки».
        </p>

        <h4>Связанные разделы</h4>
        <p>
          «Карточка задачи», «Карточка проекта», «Задачи», «Проекты», «Шаблоны и
          черновики».
        </p>
      </>
    ),
  },
  {
    id: "task-card",
    label: "Карточка задачи",
    content: (
      <>
        <h3>Карточка задачи</h3>
        <p>
          Открывается нажатием на задачу. Состав вкладок зависит от состояния
          задачи: у часовой задачи нет вкладки «Учёт времени», у новой задачи
          нет «Обсуждения», «Вложений», «Истории».
        </p>

        <h4>Вкладка «Данные»</h4>
        <ul>
          <li>
            <b>Название</b> - обязательно.
          </li>
          <li>
            <b>Суммарная задача</b> - галочка ставится автоматически, если есть
            подзадачи.
          </li>
          <li>
            <b>Часовая задача</b> - фиксирует начало и конец в один день, план =
            разница времени.
          </li>
          <li>
            <b>Описание</b> - свободный текст.
          </li>
          <li>
            <b>Метки</b> - текстовое поле под описанием. Разделители - запятая и
            пробел. Подробнее см. раздел «Метки».
          </li>
          <li>
            <b>Проект</b> - обязателен. Кнопка «Перейти» открывает карточку
            проекта.
          </li>
          <li>
            <b>Исполнитель</b> - обязателен. Если назначающий не является прямым
            руководителем исполнителя, задача уходит на согласование.
          </li>
          <li>
            <b>Плановые часы</b> - обязательны для производственных проектов;
            для административных не требуются.
          </li>
          <li>
            <b>Приоритет</b> - низкий / средний / высокий / критический.
          </li>
          <li>
            <b>Статус</b> - новый / в работе / на проверке / закрыт / отменён.
          </li>
          <li>
            <b>Начало</b> и <b>Срок исполнения</b> - начало обязательно для
            всех. Срок не может быть в прошлом.
          </li>
          <li>
            <b>Время начала</b> и <b>окончания</b> - только у часовых задач.
          </li>
          <li>
            <b>Зависимость</b> - предшественник и тип (FS / SS / FF).
          </li>
        </ul>
        <p>
          Кнопки «Запросить изменение часов» и «Запросить изменение срока»
          доступны исполнителю - они отправляют запрос директору.
        </p>

        <h4>Отображение меток</h4>
        <ul>
          <li>
            В режиме редактирования - только поле «Метки». Ярлыки появятся после
            сохранения.
          </li>
          <li>
            В режиме просмотра - строка ярлыков под описанием. Нажатие на ярлык
            открывает список задач и проектов с этой меткой.
          </li>
        </ul>

        <h4>Вкладка «Учёт времени»</h4>
        <p>
          Прогресс-бар «факт / план», список записей часов и форма добавления.
          Правила:
        </p>
        <ul>
          <li>Одна запись на дату.</li>
          <li>Дата не в будущем и в границах задачи.</li>
          <li>Не больше свободного остатка плана.</li>
          <li>
            При превышении дневной нормы (или внесении в выходной/праздник) -
            предупреждение с подтверждением, но не блокировка.
          </li>
          <li>
            Править и удалять может только исполнитель задачи или администратор.
          </li>
        </ul>
        <p>
          Сортировка - кнопки «По дате» / «По часам» в панели над списком
          записей.
        </p>

        <h4>Вкладка «Подзадачи»</h4>
        <p>
          Таблица подзадач с кнопкой «Создать подзадачу». Нажатие по строке
          открывает карточку подзадачи с возвратом к родителю.
        </p>
        <p>
          Правило: план родителя ≥ собственных фактов + суммы планов подзадач.
          При добавлении подзадачи с слишком большим планом сохранение
          блокируется с понятным сообщением.
        </p>

        <h4>Вкладка «Обсуждение»</h4>
        <p>
          Чат с вложениями-изображениями, @упоминаниями и реакциями. Автор
          задачи, исполнитель и ответственный по проекту автоматически получают
          уведомления о новых сообщениях.
        </p>

        <h4>Вкладка «Вложения»</h4>
        <p>
          Файлы задачи с версионированием и папками. Разрешены PDF, DOC(X),
          XLS(X), PPT(X), ZIP, TXT, CSV, PNG, JPEG, GIF, WEBP до 25 МБ.
        </p>

        <h4>Вкладка «История»</h4>
        <p>
          Изменения полей и действий: смена исполнителя, срока, статуса, плана,
          меток, добавление записей часов, комментарии к логам.
        </p>

        <h4>Вкладка «Заметки»</h4>
        <p>
          Личные заметки исполнителя. Видны только исполнителю задачи. Хранятся
          отдельно от формы задачи - сохранение не требует сохранения самой
          задачи.
        </p>

        <h4>Черновик</h4>
        <p>
          Кнопка «В черновики» сохраняет задачу как личный черновик. Такая
          задача не отображается в рабочих списках; видна автору в разделе
          «Черновики». При сохранении в рабочий статус запускается согласование
          назначения (если требуется).
        </p>

        <h4>Особые случаи</h4>
        <ul>
          <li>Задача в архиве - только чтение, редактирование запрещено.</li>
          <li>Часовая задача - вкладка «Учёт времени» скрыта.</li>
          <li>
            Перегрузка исполнителя - предупреждение с суммой часов и ёмкостью.
          </li>
          <li>Отпуск исполнителя в период задачи - предупреждение.</li>
          <li>
            При закрытии родителя подзадачи не архивируются автоматически, но
            попадают в архив по общим правилам.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "drafts",
    label: "Черновики",
    content: (
      <>
        <h3>Раздел «Черновики»</h3>
        <p>
          Здесь хранятся ваши личные черновики задач и проектов. Черновик - это
          заготовка, которая ещё не в рабочем статусе: она не отображается ни в
          одном рабочем списке. Автор видит её в разделе «Черновики»;
          согласующий - в «Запросах и заявках», если черновик отправлен на
          согласование.
        </p>

        <h4>Как создать черновик</h4>
        <ol>
          <li>В карточке новой задачи/проекта заполните поля.</li>
          <li>Нажмите «В черновики» (левая часть футера).</li>
          <li>Объект сохранится со статусом «Черновик».</li>
        </ol>

        <h4>Что видно в разделе</h4>
        <ul>
          <li>
            Таблица задач-черновиков: название, исполнитель, статус,
            согласующий, дата создания.
          </li>
          <li>
            Таблица проектов-черновиков: название, код, ответственный, статус,
            согласующий, дата создания.
          </li>
          <li>Статус «Личный черновик» - обычная заготовка.</li>
          <li>
            Статус «На согласовании» - заготовка уже отправлена руководителю
            исполнителя (см. «Согласование назначений»).
          </li>
        </ul>

        <h4>Дальнейшие шаги</h4>
        <ul>
          <li>
            Нажатие по строке открывает карточку - можно продолжить
            редактирование.
          </li>
          <li>
            При сохранении в рабочий статус запускается согласование (если
            требуется по правилам).
          </li>
          <li>
            Решения по согласованию приходят в раздел «Запросы и заявки» →
            «Согласование назначений».
          </li>
        </ul>

        <h4>Отличия от «Запросов и заявок»</h4>
        <p>
          «Черновики» - рабочее место автора. «Согласование назначений» -
          рабочее место согласующего. Это два разных раздела. Автор видит свой
          черновик, согласующий - заявку.
        </p>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Черновик нельзя удалить из карточки - только через контекстное меню
            в разделе «Черновики».
          </li>
          <li>
            Черновик не виден на доске задач, в списке, диаграмме Ганта и
            календаре.
          </li>
          <li>
            После согласования задача переходит в статус «Новая», проект - в
            «Активный».
          </li>
          <li>
            При отклонении объект возвращается в черновики, поле исполнителя
            очищается.
          </li>
        </ul>

        <h4>Связанные разделы</h4>
        <p>
          «Согласование назначений», «Запросы и заявки», «Карточка задачи»,
          «Карточка проекта».
        </p>
      </>
    ),
  },
  {
    id: "approval",
    label: "Согласование назначений",
    content: (
      <>
        <h3>Согласование назначений</h3>
        <p>
          Когда назначающий не является прямым руководителем исполнителя,
          назначение уходит на согласование. Это защита от «сюрпризов»:
          руководитель должен знать, кто берёт в работу его подчинённого.
        </p>

        <h4>Когда требуется согласование</h4>
        <ul>
          <li>Назначающий - не прямой руководитель исполнителя.</li>
          <li>Исполнитель - не сам назначающий.</li>
          <li>
            У исполнителя есть прямой руководитель (начальник отдела, главный
            конструктор КБ или генеральный директор).
          </li>
        </ul>
        <p>
          Прямой руководитель определяется по <b>основному</b> подразделению
          исполнителя. Для главного конструктора КБ прямой руководитель -
          генеральный директор. Если основного подразделения нет - директор.
        </p>

        <h4>Как это выглядит</h4>
        <ul>
          <li>
            Задача или проект сохраняется со статусом <code>draft</code> и полем
            «На согласовании».
          </li>
          <li>
            Согласующий (прямой руководитель исполнителя) получает уведомление
            со ссылкой на объект.
          </li>
          <li>
            Автор видит запись в разделе <b>«Черновики»</b> со статусом «На
            согласовании» и именем согласующего.
          </li>
        </ul>

        <h4>Решение согласующего</h4>
        <ul>
          <li>
            <b>Согласовать</b> - задача переходит в статус «Новая», проект - в
            «Активный».
          </li>
          <li>
            <b>Переназначить</b> - выбрать другого сотрудника из своего
            подразделения. Исходный исполнитель заменяется, объект активируется.
          </li>
          <li>
            <b>Отклонить</b> - объект возвращается в черновики автору, поле
            исполнителя очищается. Причина отклонения обязательна.
          </li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Административные проекты не согласуются: у них нет поля
            «Ответственный».
          </li>
          <li>
            Если назначающий - руководитель исполнителя, согласование не
            требуется.
          </li>
          <li>
            Если исполнитель - сам назначающий, согласование не требуется.
          </li>
          <li>
            После отклонения автор может выбрать другого исполнителя и сохранить
            заново - согласование запустится снова.
          </li>
          <li>
            Заявки на согласование видны в разделе <b>«Запросы и заявки»</b> →
            вкладка «Согласование назначений». Там же кнопки решения.
          </li>
        </ul>

        <h4>Связанные разделы</h4>
        <p>
          «Черновики», «Запросы и заявки», «Карточка задачи», «Карточка
          проекта», «Роли и права».
        </p>
      </>
    ),
  },
  {
    id: "projects",
    label: "Проекты",
    content: (
      <>
        <h3>Раздел «Проекты»</h3>
        <p>
          Проекты бывают производственные и административные. Первый привязан к
          КБ, имеет план часов, договор, ставку, ответственного и тип ВС. Второй
          - внутренний проект предприятия без экономических реквизитов.
        </p>

        <h4>Режимы отображения</h4>
        <ul>
          <li>
            <b>Доска задач</b> - четыре колонки: Неактивный / Активный / Закрыт
            / Отменён.
          </li>
          <li>
            <b>Список</b> - карточки с прогрессом план / факт, аватарами
            исполнителей и значком непрочитанных. Раскладка переключается между
            «Плиткой» и «Полосой».
          </li>
        </ul>

        <h4>Фильтры</h4>
        <ul>
          <li>Проект - выпадающий список с поиском по коду и названию.</li>
          <li>Статус / Тип / Приоритет.</li>
          <li>Участник - сотрудник, у которого есть задачи в проекте.</li>
          <li>Отдел - фильтр по подразделению исполнителя.</li>
          <li>
            <b>Метка</b> - фильтр по метке из числа тех, что встречаются у
            проектов в текущей выборке.
          </li>
          <li>«Окончание до» - поле даты. Пустое поле не фильтрует.</li>
        </ul>

        <h4>Ярлыки меток на карточках</h4>
        <p>
          Если у проекта есть метки, они показываются под названием. Нажатие на
          ярлык открывает список всех задач и проектов с этой меткой.
        </p>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Долгосрочный административный проект (<code>longterm: true</code>)
            не архивируется автоматически.
          </li>
          <li>При закрытии или отмене проекта все его задачи архивируются.</li>
          <li>
            Доступ к проекту можно выдать явно (кнопка «Доступ») сотрудникам,
            которые не видят его по роли.
          </li>
        </ul>

        <h4>Связанные разделы</h4>
        <p>«Карточка проекта», «Метки», «Задачи», «Бюджеты и планы».</p>
      </>
    ),
  },
  {
    id: "project-card",
    label: "Карточка проекта",
    content: (
      <>
        <h3>Карточка проекта</h3>

        <h4>Вкладка «Информация»</h4>
        <ul>
          <li>
            <b>Название</b>, <b>Заказчик</b> - обязательны.
          </li>
          <li>
            <b>Описание</b> - свободный текст.
          </li>
          <li>
            <b>Метки</b> - текстовое поле под описанием. Разделители - запятая и
            пробел. Подробнее см. раздел «Метки».
          </li>
          <li>
            <b>Тип проекта</b> - производственный или административный.
          </li>
          <li>
            <b>Код</b> - короткий идентификатор (например, <code>ЛМ-24</code>).
          </li>
          <li>
            <b>Тип ВС</b> (для производственных) - Су-57, МиГ-35, Ту-160, Ил-76,
            Ка-52, Другой.
          </li>
          <li>
            <b>Категория</b> (для производственных) - Ремонт, Модификация, КС,
            ИКУ.
          </li>
          <li>
            <b>Приоритет</b> - AOG / CRIT / NORM для производственных; высокий /
            средний / низкий для административных.
          </li>
          <li>
            <b>Подразделения</b> - для производственного только КБ; для
            административного - КБ и отделы вне КБ.
          </li>
          <li>
            <b>Дата начала</b> - обязательна для всех типов проектов.
            <b>Дата окончания</b> - обязательна для производственного.
          </li>
          <li>
            <b>Плановые часы</b> - обязательны для производственного.
          </li>
          <li>
            <b>Статус</b> - активный / неактивный / закрыт / отменён.
          </li>
          <li>
            <b>Номер договора</b> и <b>ставка ₽/ч</b> - только для admin,
            director, economist и accountant.
          </li>
          <li>
            <b>Ответственный</b> - только для производственных проектов.
          </li>
          <li>
            <b>Галерея фото</b> - можно загружать изображения, выбирать главное.
          </li>
        </ul>

        <h4>Отображение меток</h4>
        <ul>
          <li>
            В режиме редактирования - только поле «Метки». Ярлыки появятся после
            сохранения.
          </li>
          <li>
            В режиме просмотра - строка ярлыков под описанием. Нажатие на ярлык
            открывает список задач и проектов с этой меткой.
          </li>
        </ul>

        <h4>Вкладка «Задачи»</h4>
        <p>
          Таблица задач проекта с колонками задачи, исполнителя, статуса, плана,
          факта, дедлайна. Кнопка «Создать задачу» открывает форму с уже
          подставленным проектом.
        </p>

        <h4>Вкладка «Чат проекта»</h4>
        <p>
          Обсуждение проекта. Сюда попадают и комментарии из задач - со ссылкой
          на задачу, чтобы было понятно, о чём речь.
        </p>

        <h4>Вкладка «Вложения»</h4>
        <p>Файлы проекта с версионированием и папками - как в задаче.</p>

        <h4>Вкладка «История»</h4>
        <p>
          Изменения полей: название, код, статус, приоритет, ответственный,
          даты, план, метки, экономические реквизиты.
        </p>

        <h4>Футер</h4>
        <ul>
          <li>
            <b>Удалить проект</b> - только для администратора.
          </li>
          <li>
            <b>Копировать</b> - создаёт новый проект на основе текущего.
          </li>
          <li>
            <b>В шаблон</b> - сохранить проект как шаблон с деревом задач.
          </li>
          <li>
            <b>Доступ</b> - открыть диалоговое окно управления явным доступом.
          </li>
          <li>
            <b>В черновики</b> - сохранить как личный черновик.
          </li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Уменьшить план проекта ниже суммы планов корневых задач нельзя.
          </li>
          <li>
            Экономист и бухгалтер могут менять только «Номер договора» и
            «Ставку».
          </li>
          <li>
            Ответственного можно назначать только из списка доступных
            сотрудников.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "project-access",
    label: "Доступ к проекту",
    content: (
      <>
        <h3>Доступ к проекту</h3>
        <p>
          По умолчанию проект виден сотрудникам по ролям, КБ, отделам и задачам.
          Кнопка <b>«Доступ»</b> в футере карточки проекта позволяет открыть
          проект точечно - сотрудникам, которые иначе его не видят.
        </p>

        <h4>Кто может управлять доступом</h4>
        <ul>
          <li>
            Администратор, директор, менеджер проектов - для любого проекта.
          </li>
          <li>Главный конструктор КБ - для проектов своего КБ.</li>
        </ul>

        <h4>Окно «Доступ к проекту»</h4>
        <ul>
          <li>
            Список всех активных сотрудников с поиском по ФИО и должности.
          </li>
          <li>
            Сотрудники, которые видят проект по своим ролям, отмечены и{" "}
            <b>защищены от снятия</b> - рядом подпись «доступ по роли». Их
            доступ управляется ролями, а не этим окном.
          </li>
          <li>
            Остальные - обычные флажки. Их состояние хранится в{" "}
            <code>project.access.userIds</code>.
          </li>
        </ul>

        <h4>Что видит сотрудник с явным доступом</h4>
        <ul>
          <li>
            Проект появляется в разделе «Проекты» (в списке и на доске задач).
          </li>
          <li>
            Задачи проекта видны в разделе «Задачи», если сотрудник попадает в
            выборку по другим правилам.
          </li>
          <li>
            В карточке проекта доступны все вкладки, кроме тех, что ограничены
            ролью (например, экономические поля - только для admin, director,
            economist и accountant).
          </li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Явный доступ не даёт прав на редактирование - только на просмотр.
          </li>
          <li>
            При закрытии или отмене проекта доступ сохраняется, но проект уходит
            в архив и становится доступен только для чтения.
          </li>
          <li>При восстановлении проекта доступ сохраняется.</li>
          <li>В истории проекта фиксируется, кому открыт доступ и кем.</li>
        </ul>

        <h4>Связанные разделы</h4>
        <p>«Карточка проекта», «Проекты», «Роли и права».</p>
      </>
    ),
  },
  {
    id: "calendar",
    label: "Календарь",
    content: (
      <>
        <h3>Раздел «Календарь»</h3>
        <p>
          Три режима: день, неделя, месяц. Переключение - сегментом в правой
          части шапки раздела.
        </p>

        <h4>Что видно</h4>
        <ul>
          <li>
            Задачи по полю «Срок исполнения». Задачи без срока не показываются.
          </li>
          <li>Ярлыки с названием, цветом проекта и аватаром исполнителя.</li>
          <li>Сегодняшний день выделен в месячной сетке.</li>
        </ul>

        <h4>Действия</h4>
        <ul>
          <li>Навигация по периодам стрелками, кнопка «Сегодня».</li>
          <li>Нажатие на ярлык - открыть задачу.</li>
          <li>
            Контекстное меню (правый щелчок или кнопка «⋯») - «Открыть»,
            «Перевести в статус», «Копировать», «В шаблон», «Удалить».
          </li>
          <li>
            Переключатель «Все задачи» - выключен: только задачи, где вы
            исполнитель; включён: все доступные.
          </li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>В режиме «Месяц» показывается до 3 ярлыков в день.</li>
          <li>В режиме «Неделя» и «День» - до 12 ярлыков.</li>
        </ul>
      </>
    ),
  },
  {
    id: "gantt",
    label: "Диаграмма Ганта",
    content: (
      <>
        <h3>Раздел «Диаграмма Ганта»</h3>
        <p>
          Временная шкала задач. Слева - список с деревом подзадач, справа -
          полосы задач на календарной сетке.
        </p>

        <h4>Периоды</h4>
        <ul>
          <li>Месяц / Квартал / Год - переключатель в правом верхнем углу.</li>
          <li>
            Стрелки влево-вправо сдвигают период, «Сегодня» возвращает к текущей
            дате.
          </li>
          <li>Зум: 50 % – 200 %.</li>
        </ul>

        <h4>Управление</h4>
        <ul>
          <li>
            <b>Свернуть всё / Развернуть всё</b> - работа с деревом задач.
          </li>
          <li>
            <b>Полноэкранный режим</b> - выход по Esc.
          </li>
          <li>
            Ширину левой колонки можно менять перетаскиванием разделителя.
          </li>
        </ul>

        <h4>Полосы задач</h4>
        <ul>
          <li>Заполнение полосы показывает процент факта от плана.</li>
          <li>Цвет полосы - по приоритету задачи.</li>
          <li>Иконка 🏖 - исполнитель в отпуске в период задачи.</li>
          <li>Красная точка - задача просрочена.</li>
          <li>У закрытых и отменённых - своя подпись прямо в полосе.</li>
        </ul>

        <h4>Перетаскивание</h4>
        <ul>
          <li>Перетаскивание центра полосы сдвигает задачу целиком.</li>
          <li>Перетаскивание края изменяет дату начала или окончания.</li>
          <li>Esc при перетаскивании отменяет действие.</li>
          <li>
            Задачи с зависимостью сдвигать нельзя - сначала уберите зависимость.
          </li>
        </ul>

        <h4>Стрелки зависимостей</h4>
        <p>
          Между связанными задачами рисуются стрелки. Красный цвет -
          предшественник просрочен, но последователь уже начался.
        </p>

        <h4>Легенда</h4>
        <p>
          Внизу - легенда с двумя элементами: «🏖 исполнитель в отпуске» и
          «Заполнение полосы - факт / план».
        </p>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Задачи без даты начала или срока в диаграмму Ганта не попадают.
            Недавно закрытые задачи отображаются (до автоматической архивации
            через 3 месяца).
          </li>
          <li>
            Праздники и сокращённые дни подсвечены по производственному
            календарю.
          </li>
          <li>
            При наведении на полосу - подробная всплывающая подсказка с
            проектом, статусом, приоритетом, планом/фактом, сроком,
            исполнителем, отметкой об отпуске.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "templates",
    label: "Шаблоны",
    content: (
      <>
        <h3>Раздел «Шаблоны»</h3>
        <p>
          Шаблон - сохранённая заготовка полей задачи или проекта с опциональным
          деревом подзадач / задач. При создании новой сущности шаблон
          подставляется в форму одним нажатием.
        </p>

        <h4>Типы шаблонов</h4>
        <ul>
          <li>
            <b>Личный</b> - видите только вы. Редактируется и удаляется вами.
          </li>
          <li>
            <b>Общий</b> - виден всем сотрудникам. Редактирует владелец (или
            администратор).
          </li>
        </ul>

        <h4>Создание</h4>
        <ol>
          <li>
            Кнопка «Создать шаблон» → «Шаблон задачи» или «Шаблон проекта».
          </li>
          <li>
            Вкладка «Информация» - название, флажок «Общий», поля сущности.
          </li>
          <li>
            Вкладка «подзадачи» (для шаблона задачи) или «задачи» (для шаблона
            проекта) - дерево с числом узлов.
          </li>
          <li>
            Кнопка «+ подзадача» / «+ задача» добавляет узел, нажатие на узел -
            редактор.
          </li>
          <li>Кнопка «Сохранить» создаёт шаблон.</li>
        </ol>

        <h4>Создание из существующей сущности</h4>
        <p>
          В карточке задачи или проекта - кнопка «В шаблон». Поля, метки и
          дерево подхватятся автоматически, при необходимости скорректируйте.
        </p>

        <h4>Метки в шаблонах</h4>
        <p>
          Метки хранятся в payload шаблона массивом. При сохранении существующей
          сущности как шаблона они попадают в payload автоматически. При
          применении шаблона к новой сущности метки подставляются в поле
          «Метки». В узлах дерева шаблона поле «Метки» доступно в редакторе
          узла.
        </p>

        <h4>Применение</h4>
        <p>
          В начале формы создания задачи или проекта - выпадающий список
          «Шаблон». После применения поля заполнены, вверху видно плашку
          «Применён шаблон: …». Вложенные подзадачи материализуются после
          сохранения родителя.
        </p>

        <h4>Фильтры</h4>
        <ul>
          <li>Тип: все / задачи / проекты.</li>
          <li>Принадлежность: все / мои / общие.</li>
          <li>Поиск по названию.</li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Общий шаблон редактирует только владелец. Чужие общие - только
            просмотр.
          </li>
          <li>
            Одинаковые названия не запрещены, но ищите по владельцу и дате
            обновления.
          </li>
          <li>
            Удаление шаблона не затрагивает созданные по нему задачи и проекты.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "staff",
    label: "Персонал",
    content: (
      <>
        <h3>Раздел «Персонал»</h3>
        <p>Две вкладки: «Сотрудники» и «Загрузка».</p>

        <h4>Вкладка «Сотрудники»</h4>
        <ul>
          <li>
            Список по КБ и отделам, секции «Руководство», «Отделы вне КБ»,
            «Архив сотрудников».
          </li>
          <li>
            Аватар, ФИО, должность, значок ролей (СУП, ГД, ГЭ, БУХ, ГК, РО, ОП,
            МП, HR, ИСП).
          </li>
          <li>
            Значок «в отпуске до даты», «Уволен», «N ст.» при неполной ставке.
          </li>
          <li>
            Нажатие по строке открывает карточку сотрудника только для
            просмотра: ФИО, должности, подразделения, вн. телефон, e-mail,
            активные замещения.
          </li>
          <li>
            Меню действий справа: Редактировать, Подразделения, Роли, Уволить /
            Восстановить.
          </li>
        </ul>

        <h4>Фильтры</h4>
        <ul>
          <li>Поиск по сотруднику, должности, отделу.</li>
          <li>КБ: все / любое КБ / конкретное КБ / вне КБ.</li>
          <li>Отдел: все / любой отдел / конкретный / вне отделов.</li>
          <li>Роль.</li>
        </ul>

        <h4>Диалоговое окно «Роли»</h4>
        <ul>
          <li>Флажки всех ролей.</li>
          <li>Для роли «Главный конструктор» - выбор КБ.</li>
          <li>
            Роль «Руководитель отдела» получает руководимые отделы автоматически
            из своих подразделений.
          </li>
          <li>Роль «Исполнитель» - disabled, «назначается автоматически».</li>
        </ul>

        <h4>Диалоговое окно «Подразделения»</h4>
        <ul>
          <li>
            Список отделов; у каждого справа указано, к какому КБ он относится
            (или «вне КБ»).
          </li>
          <li>Кнопка «Сделать основным» для одного отдела.</li>
          <li>
            Для дополнительных отделов - своя должность и ставка (0.1 – 1).
          </li>
          <li>
            Отдельный пункт «Вне отделов» - должность без привязки к отделу.
          </li>
        </ul>

        <h4>Создание сотрудника</h4>
        <p>
          Кнопка «Добавить сотрудника» (для admin/director/hr): ФИО, e-mail,
          пароль, должность, вн. телефон, табельный №, роли.
        </p>

        <h4>Увольнение</h4>
        <p>
          «Уволить» - сотрудник перемещается в архив. Если увольняется текущий
          пользователь, сессия сбрасывается. Восстановить можно через «Архив
          сотрудников» → «Показать» → «Восстановить».
        </p>

        <h4>Отпуска сотрудников</h4>
        <p>
          Для admin/director/hr - общая таблица всех отпусков. Набор строк
          зависит от текущих фильтров раздела «Персонал». Кнопка «Отпуск
          сотруднику» создаёт новый.
        </p>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Эффективная ставка = 1, если есть основное подразделение; иначе -
            сумма ставок по совмещениям (≤ 1).
          </li>
          <li>
            Если сотрудник является главным конструктором, его основное место -
            КБ, все отделы считаются совмещениями.
          </li>
          <li>
            Все перечисленные действия требуют соответствующих прав (см. «Роли и
            права»).
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "workload",
    label: "Загрузка",
    content: (
      <>
        <h3>Вкладка «Загрузка» (Персонал)</h3>
        <p>
          Сводный дашборд план / факт по каждому сотруднику за выбранный период
          с процентом загрузки.
        </p>

        <h4>Периоды</h4>
        <ul>
          <li>Месяц / Квартал / Год / Период - сегмент в шапке.</li>
          <li>
            Стрелки переключают период, «Сегодня» возвращает к текущей дате.
          </li>
          <li>В режиме «Период» - два поля с датами.</li>
        </ul>

        <h4>Таблица</h4>
        <ul>
          <li>
            <b>Сотрудник</b> - ФИО; значок «N ст.» при неполной ставке.
          </li>
          <li>
            <b>Подразделение</b> - основное.
          </li>
          <li>
            <b>План</b> - полоса и число часов.
          </li>
          <li>
            <b>Факт</b> - полоса и число часов.
          </li>
          <li>
            <b>Загрузка</b> - процент; больше 100 % - красным.
          </li>
          <li>Итоговая строка «Итого».</li>
        </ul>

        <h4>Модель расчёта</h4>
        <ul>
          <li>
            План задачи распределяется «остатком к выполнению»: всё, что уже
            прошло, считается закрытым фактом, остаток перетекает вперёд.
          </li>
          <li>
            Ёмкость сотрудника = норма часов × эффективная ставка минус
            сокращённые дни.
          </li>
          <li>Задачи без дат и закрытые в загрузку не входят.</li>
        </ul>

        <h4>Действия</h4>
        <ul>
          <li>Поиск по сотруднику и отделу.</li>
          <li>Сортировка: сотрудник, подразделение, план, факт, загрузка.</li>
          <li>
            Нажатие по строке - диалоговое окно «Задачи сотрудника» с периодом.
          </li>
        </ul>

        <h4>Диалоговое окно «Задачи сотрудника»</h4>
        <p>
          Список задач с остатком плана и сроком. Нажатие на название открывает
          карточку задачи; при возврате период сохраняется.
        </p>
      </>
    ),
  },
  {
    id: "reports",
    label: "Отчёты",
    content: (
      <>
        <h3>Раздел «Отчёты»</h3>
        <p>Пять типов отчётов, доступных по ролям.</p>

        <h4>Типы</h4>
        <ul>
          <li>
            <b>Задачи</b> - таблица задач с фильтрами по датам создания, сроку,
            дате закрытия, проекту, исполнителю, статусу, приоритету, заказчику.
          </li>
          <li>
            <b>Проекты</b> - реквизиты, план / факт, ответственные.
          </li>
          <li>
            <b>Сотрудники</b> - агрегаты по исполнителям: план, факт, количество
            задач.
          </li>
          <li>
            <b>Трудозатраты</b> - журнал списаний часов по дням.
          </li>
          <li>
            <b>Выручка по НЗП</b> - экономический отчёт по незакрытым задачам;
            только admin, director, economist, accountant.
          </li>
        </ul>

        <h4>Сохранённые шаблоны фильтров</h4>
        <p>
          Любой набор фильтров можно сохранить: введите имя и нажмите «Сохранить
          фильтр». Шаблон появится карточкой с описанием условий и кнопками
          «Загрузить» и «Удалить».
        </p>

        <h4>Выгрузка</h4>
        <p>
          Кнопка «Выгрузить CSV» - файл с разделителем «;» и BOM, открывается в
          Excel без плясок с кодировкой. Формулы в ячейках обезврежены: если
          значение начинается с «=», «+», «-», «@», перед ним ставится апостроф.
        </p>

        <h4>Выручка по НЗП</h4>
        <ul>
          <li>
            Таблица: код проекта, номер договора, заказчик, ставка ₽/ч, часы НЗП
            за период, затраты ₽.
          </li>
          <li>Итоговая строка.</li>
          <li>
            Отдельная таблица «Без ставки» - проекты, по которым не задана
            ставка, с часами и пометкой «-».
          </li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Отчёт «Выручка по НЗП» виден только ролям admin, director,
            economist, accountant.
          </li>
          <li>
            Сохранённые шаблоны хранятся в localStorage - общие для всех ваших
            сессий в одном браузере.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "archive",
    label: "Архив",
    content: (
      <>
        <h3>Раздел «Архив»</h3>
        <p>
          Закрытые и отменённые задачи и проекты. Сюда попадают сущности со
          статусом «Закрыт» или «Отменён», а также автоматически архивированные
          через 3 месяца после закрытия.
        </p>

        <h4>Таблицы</h4>
        <ul>
          <li>
            <b>Архивные проекты</b> - код, название, тип, дата архивации, кнопки
            «Открыть» и «Восстановить».
          </li>
          <li>
            <b>Архивные задачи</b> - задача, проект, исполнитель, дата
            архивации, кнопки «Открыть» и «Восстановить».
          </li>
        </ul>

        <h4>Фильтры</h4>
        <ul>
          <li>Период архивации (две даты).</li>
          <li>Проект, исполнитель, отдел.</li>
        </ul>

        <h4>Восстановление</h4>
        <ul>
          <li>
            Задачу нельзя восстановить, пока проект в архиве. Сначала
            восстановите проект.
          </li>
          <li>Восстановление проекта восстанавливает и все его задачи.</li>
          <li>Восстановление доступно admin, director, project_manager.</li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>Архивные сущности открываются только для чтения.</li>
          <li>
            Долгосрочные административные проекты (<code>longterm</code>) не
            архивируются автоматически.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "requests",
    label: "Запросы и заявки",
    content: (
      <>
        <h3>Раздел «Запросы и заявки»</h3>
        <p>Пять видов заявок. Набор видимых вкладок зависит от ролей.</p>

        <h4>Изменение часов</h4>
        <ul>
          <li>
            Исполнитель просит увеличить или уменьшить план задачи или проекта.
          </li>
          <li>Решение принимает директор (или админ).</li>
          <li>
            При одобрении в историю сущности добавляется запись, обновляется
            план.
          </li>
        </ul>

        <h4>Изменение срока</h4>
        <ul>
          <li>Исполнитель просит сдвинуть срок задачи или проекта.</li>
          <li>Решение принимает директор (или админ).</li>
        </ul>

        <h4>Согласование назначений</h4>
        <ul>
          <li>
            Появляется, когда назначающий не является прямым руководителем
            исполнителя.
          </li>
          <li>
            Согласующий видит три кнопки: «Согласовать», «Переназначить»,
            «Отклонить».
          </li>
          <li>«Переназначить» - выбор сотрудника из своего подразделения.</li>
          <li>
            При отклонении объект возвращается в черновики автору, поле
            исполнителя очищается.
          </li>
        </ul>

        <h4>Передача ролей и замещения</h4>
        <ul>
          <li>Таблица: от кого, кому, повод, период, роли, статус.</li>
          <li>Получатель - «Принять» или «Отклонить» (причина обязательна).</li>
          <li>
            Admin и director - «Применить сейчас» (в обход ожидания получателя).
          </li>
          <li>
            Активное замещение можно «Отозвать» или «Завершить» при истечении
            срока.
          </li>
        </ul>

        <h4>Заявки на регистрацию</h4>
        <ul>
          <li>
            Приходят администратору после самостоятельной регистрации нового
            сотрудника.
          </li>
          <li>Кнопки «Одобрить» / «Отклонить».</li>
          <li>При одобрении создаётся учётная запись с ролью «Исполнитель».</li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Причина отклонения обязательна - пустое поле блокирует кнопку.
          </li>
          <li>
            Решение по заявке принимается один раз: повторное нажатие
            невозможно.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "journal",
    label: "Журнал аудита",
    content: (
      <>
        <h3>Журнал аудита</h3>
        <p>
          История всех значимых действий в системе: создание, изменение,
          удаление сущностей, утверждение заявок, решения по замещениям,
          отправка напоминаний, автоподъём планов. Видят только admin и
          director.
        </p>

        <h4>Фильтры</h4>
        <ul>
          <li>Период (две даты).</li>
          <li>Пользователь (все / конкретный).</li>
          <li>
            Действие - 28+ типов, включая «Создание задачи», «Изменение
            проекта», «Утверждение запроса часов», «Автоматическая архивация
            задач».
          </li>
          <li>Поиск по действию и деталям.</li>
        </ul>

        <h4>Формат записей</h4>
        <ul>
          <li>Группировка по месяцам и дням.</li>
          <li>Дата и время в моноширинном шрифте.</li>
          <li>Пользователь с аватаром; для системных действий - «Система».</li>
          <li>Действие и детали (раскрываются как key: value).</li>
          <li>Пагинация по 20 записей.</li>
        </ul>

        <h4>Выгрузка</h4>
        <p>
          Кнопка «Выгрузить CSV» - экспорт всех отфильтрованных записей.
          Разделитель «;», открывается в Excel.
        </p>
      </>
    ),
  },
  {
    id: "cabinet",
    label: "Личный кабинет",
    content: (
      <>
        <h3>Личный кабинет</h3>
        <p>
          Открывается нажатием на вашу карточку в боковой панели. Состав
          вкладок:
        </p>

        <h4>Сводка</h4>
        <ul>
          <li>Таблица «Затраченные часы по задачам» за последние 20 дней.</li>
          <li>Поля «Экспорт» - выберите период и выгрузите отчёт в CSV.</li>
          <li>
            Задачи по статусам: новый, в работе, на проверке, закрыт, отменён.
          </li>
          <li>Проекты с вашим участием.</li>
        </ul>

        <h4>Мои отпуска</h4>
        <ul>
          <li>
            Таблица ваших отпусков: начало, окончание, тип, комментарий, статус.
          </li>
          <li>Кнопка «Добавить отпуск».</li>
          <li>
            Редактировать и удалять можно только отпуска, которые ещё не
            начались.
          </li>
        </ul>

        <h4>Делегирование и замещение</h4>
        <ul>
          <li>
            Список передач ролей и замещений: от кого, кому, роли, период,
            статус.
          </li>
          <li>Кнопка «Добавить» - открыть окно «Передача полномочий».</li>
          <li>
            Кнопка «Отозвать» - для активных замещений, где вы - инициатор.
          </li>
        </ul>

        <h4>Профиль и уведомления</h4>
        <ul>
          <li>
            Фото профиля: загрузка (до 5 МБ, только изображения), удаление.
          </li>
          <li>ФИО, должность, e-mail - только для чтения.</li>
          <li>Внутренний телефон - можно менять.</li>
          <li>Табельный № - только для чтения.</li>
          <li>Подразделения - список с пометкой основное / совм.</li>
          <li>
            Кнопка «Сменить пароль»: старый, новый, подтверждение; проверка
            требований и история последних 5 паролей (включая текущий).
          </li>
          <li>
            Три переключателя e-mail-уведомлений: о сроках, сводка просрочек,
            подписка на обсуждения.
          </li>
        </ul>

        <h4>Правка календаря</h4>
        <p>
          Только для администратора. См. раздел «Производственный календарь».
        </p>

        <h4>Напоминания о часах</h4>
        <p>
          Блок виден admin / director / economist. Настройки: вкл/выкл, люфт
          (0–24 ч), день недели, час МСК. Кнопки «Предпросмотр» (список
          получателей), «Отправить сейчас» (форс-рассылка), «Сохранить».
          Показывается дата последней отправки.
        </p>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Сотрудник на неполной ставке видит значок «N ст.» рядом с ФИО.
          </li>
          <li>Активное замещение видно в шапке боковой панели.</li>
          <li>
            Уволенный сотрудник выходит из сессии при попытке сменить себя.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "calendar-production",
    label: "Производственный календарь",
    content: (
      <>
        <h3>Производственный календарь</h3>
        <p>Хранит праздничные и сокращённые дни. Влияет на:</p>
        <ul>
          <li>расчёт нормы рабочего времени;</li>
          <li>ёмкость сотрудников в разделе «Загрузка»;</li>
          <li>недельные напоминания о часах.</li>
        </ul>

        <h4>Просмотр</h4>
        <p>
          Кнопка «Производственный календарь» в верхней панели - диалоговое окно
          с 12 месяцами. Статусы дней выделены цветом:
        </p>
        <ul>
          <li>рабочий - обычный;</li>
          <li>сокращённый - на 1 час меньше;</li>
          <li>выходной / праздник - красный;</li>
          <li>сегодняшний день - обведён.</li>
        </ul>
        <p>
          Кнопки влево-вправо переключают год, «Сегодня» возвращает к текущему.
        </p>

        <h4>Правка</h4>
        <p>
          Доступна только admin через «Личный кабинет» → «Правка календаря».
        </p>
        <ul>
          <li>Кнопка «Сегодня» - создать год, если его нет, и открыть его.</li>
          <li>
            Кнопка «Удалить год» - удалить все данные по году с подтверждением.
          </li>
          <li>
            Секции «Праздничные дни» и «Сокращённые дни» - списки с ярлыками.
          </li>
          <li>
            Поле ввода принимает даты в формате ДД.ММ.ГГГГ. Через пробел -
            несколько дат, через тире - диапазон: «01.01.2027 - 09.01.2027»
            развернётся в 9 дней.
          </li>
          <li>Двузначный год разворачивается: «01.01.26» → 2026.</li>
          <li>
            Валидация: все даты должны относиться к активному году, дубликаты
            запрещены, дата не должна быть в другом списке.
          </li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Календарь хранится в localStorage, не сбрасывается при перезагрузке.
          </li>
          <li>
            Праздник не учитывается при расчёте нормы; сокращённый день
            уменьшает норму на 1 час.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "date-input",
    label: "Ввод дат",
    content: (
      <>
        <h3>Ввод дат</h3>
        <p>
          В производственном календаре используется текстовый ввод дат с маской{" "}
          <code>ДД.ММ.ГГГГ</code>. Маска автоматически расставляет точки и
          разворачивает двузначный год.
        </p>

        <h4>Формат</h4>
        <ul>
          <li>
            <code>07.01.2027</code> - одна дата.
          </li>
          <li>
            <code>01.01.2027 - 09.01.2027</code> - диапазон, разворачивается во
            все дни включительно.
          </li>
          <li>
            <code>07.01.2027 08.01.2027 09.01.2027</code> - несколько дат через
            пробел.
          </li>
          <li>
            <code>01.01.26</code> - двузначный год разворачивается в{" "}
            <code>2026</code>.
          </li>
        </ul>

        <h4>Правила валидации</h4>
        <ul>
          <li>
            Дата должна существовать: <code>31.02.2027</code> - ошибка.
          </li>
          <li>Год - от 1900 до 2100.</li>
          <li>Диапазон не длиннее 366 дней.</li>
          <li>
            Даты в производственном календаре должны относиться к активному
            году.
          </li>
          <li>Дубликаты запрещены - ни внутри ввода, ни с уже добавленными.</li>
          <li>
            Дата не может быть одновременно в праздниках и сокращённых днях.
          </li>
        </ul>

        <h4>Что происходит при ошибке</h4>
        <ul>
          <li>
            Показывается всплывающее уведомление с описанием проблемы:
            «некорректная дата», «диапазон в обратном порядке», «диапазон
            длиннее 366 дней».
          </li>
          <li>Ни одна дата из ввода не добавляется - операция атомарна.</li>
        </ul>

        <h4>Где встречается</h4>
        <ul>
          <li>
            Личный кабинет → «Правка календаря» - праздники и сокращённые дни.
          </li>
        </ul>

        <h4>Связанные разделы</h4>
        <p>«Производственный календарь».</p>
      </>
    ),
  },
  {
    id: "files",
    label: "Файлы и вложения",
    content: (
      <>
        <h3>Файлы и вложения</h3>
        <p>
          Файлы прикрепляются к задачам и проектам. Хранятся в папках,
          версионируются.
        </p>

        <h4>Разрешённые форматы</h4>
        <p>
          PDF, DOC(X), XLS(X), PPT(X), ZIP, TXT, CSV, PNG, JPEG, GIF, WEBP.
          Размер одного файла - до 25 МБ.
        </p>
        <p>
          Запрещены HTML, SVG, JS и другие форматы, способные выполнить код при
          открытии.
        </p>

        <h4>Папки</h4>
        <ul>
          <li>
            Кнопка «Создать папку» - ввод имени, запрещены пустые, «.», «..»,
            слишком длинные имена.
          </li>
          <li>
            Имя не должно дублировать существующий файл или папку в том же
            месте.
          </li>
          <li>
            Удаление папки невозможно, если внутри есть файлы или подпапки.
          </li>
        </ul>

        <h4>Версионирование</h4>
        <p>
          Загрузка файла с тем же именем в ту же папку создаёт новую версию. В
          карточке документа видно «vN», а кнопка «История версий» разворачивает
          список с датой, автором и размером.
        </p>

        <h4>Публичные ссылки</h4>
        <p>
          Кнопка «Скопировать ссылку» - URL вида <code>#/file/&lt;id&gt;</code>.
          Открытие ссылки подсвечивает файл в родительской папке.
        </p>

        <h4>Поиск и «Все файлы»</h4>
        <ul>
          <li>Поле поиска фильтрует по имени во всех папках.</li>
          <li>
            Кнопка «Все файлы» - плоский список последних версий документов с
            путём к папке.
          </li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>Одна и та же версия не может быть загружена дважды.</li>
          <li>Удаление затрагивает только выбранную версию.</li>
          <li>
            В обсуждениях можно прикреплять только изображения (до 10 МБ).
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "discussions",
    label: "Обсуждения",
    content: (
      <>
        <h3>Обсуждения (чаты)</h3>
        <p>
          Встроенный чат есть у каждой задачи и каждого проекта. В проекте видны
          и комментарии из задач - со ссылкой на задачу.
        </p>

        <h4>Возможности</h4>
        <ul>
          <li>
            Ветки ответов - нажатие на «Ответить» открывает редактор с уже
            подставленным упоминанием автора.
          </li>
          <li>
            @упоминания - начните печатать «@», появятся подсказки сотрудников.
            Упомянутые получают отдельное уведомление.
          </li>
          <li>Реакции - 10 эмодзи: 👍 ❤️ 🔥 ✅ 👀 🐞 💡 🤔 🎉 ✈️.</li>
          <li>Вложения - изображения (перетаскивание или выбор файла).</li>
          <li>Закрепление - до 5 сообщений на чат.</li>
          <li>Поиск с навигацией по совпадениям - стрелки вверх/вниз.</li>
          <li>Сортировка корней - «Новые», «Старые», «Популярные».</li>
        </ul>

        <h4>Файлы и ссылки</h4>
        <p>
          В шапке обсуждения - кнопки «Файлы (N)» и «Ссылки (M)». Нажатие
          подменяет область списка сообщений на список всех вложений или всех
          ссылок из этого чата. Повторное нажатие возвращает обычный чат;
          переключение между режимами идёт без промежуточного возврата в чат.
        </p>
        <ul>
          <li>
            <b>Файлы</b> - все изображения из комментариев чата, свежие сверху.
            Нажатие на миниатюру открывает просмотрщик; кнопка «Скачать»
            сохраняет файл.
          </li>
          <li>
            <b>Ссылки</b> - все URL из текстов комментариев, включая повторные
            упоминания. Распознаются <code>http://</code>, <code>https://</code>
            , <code>mailto:</code>. Дедупликации нет: два упоминания одной
            ссылки - две строки.
          </li>
          <li>
            <b>Автоссылки в чате</b> - упомянутые в тексте URL отображаются как
            кликабельные. <code>http(s)</code> открывается в новой вкладке,{" "}
            <code>mailto:</code> - в почтовом клиенте.
          </li>
          <li>
            Схемы, отличные от трёх разрешённых (<code>javascript:</code>,{" "}
            <code>data:</code>, <code>vbscript:</code>, <code>file:</code>), не
            превращаются в ссылку - это защита от подсунутого href.
          </li>
          <li>
            Кнопки «Файлы» и «Ссылки» доступны и в архивных сущностях - история
            файлов и ссылок остаётся видимой.
          </li>
        </ul>

        <h4>Правила редактирования</h4>
        <ul>
          <li>Редактировать своё сообщение можно в течение 15 минут.</li>
          <li>Удалять - только своё и только если у него нет ответов.</li>
          <li>Закреплять может любой участник чата.</li>
        </ul>

        <h4>Непрочитанные</h4>
        <p>
          При открытии чата отметка «прочитано до» двигается. Значок с числом
          непрочитанных виден:
        </p>
        <ul>
          <li>на вкладке «Обсуждение» в карточке задачи/проекта;</li>
          <li>на карточках задач и проектов в списках и на доске задач.</li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>В архивных сущностях добавление комментариев запрещено.</li>
          <li>
            Комментарий с ответами удалить нельзя - сначала удалите ответы.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "notifications",
    label: "Уведомления",
    content: (
      <>
        <h3>Уведомления</h3>
        <p>
          Колокольчик в верхней панели со счётчиком непрочитанных. Нажатие
          открывает панель со списком, сгруппированным по дням («Сегодня», далее
          - по дате).
        </p>

        <h4>Что приходит</h4>
        <ul>
          <li>Назначение и переназначение задачи.</li>
          <li>Изменение статуса, срока, плановых часов.</li>
          <li>Комментарии и @упоминания.</li>
          <li>Создание задачи/проекта в проекте, где вы ответственный.</li>
          <li>Запросы на изменение часов и сроков.</li>
          <li>Решения по согласованию назначений.</li>
          <li>Решения по отпускам.</li>
          <li>Решения по замещениям.</li>
          <li>Заявки на регистрацию (администратору).</li>
          <li>Напоминания о часах.</li>
        </ul>

        <h4>Навигация</h4>
        <p>Нажатие на уведомление открывает нужный объект:</p>
        <ul>
          <li>задача - её карточка, возможно сразу на нужной вкладке;</li>
          <li>проект - его карточка;</li>
          <li>отпуск - карточка отпуска;</li>
          <li>
            заявка - раздел «Запросы и заявки» на соответствующей вкладке.
          </li>
        </ul>
        <p>«Прочитать все» - отметить все уведомления как прочитанные.</p>

        <h4>E-mail-дубли</h4>
        <p>
          Настраиваются в личном кабинете: сроки, сводка просрочек, подписка на
          обсуждения. Критичные уведомления (восстановление пароля, утверждения)
          отключить нельзя.
        </p>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Панель закрывается нажатием вне, по Esc или повторным нажатием на
            колокольчик.
          </li>
          <li>Уведомления не переживают перезагрузку страницы.</li>
        </ul>
      </>
    ),
  },
  {
    id: "roles",
    label: "Роли и права",
    content: (
      <>
        <h3>Роли и права</h3>
        <p>Сотрудник может иметь несколько ролей одновременно.</p>

        <h4>Список ролей</h4>
        <ul>
          <li>
            <b>Суперадминистратор (СУП)</b> - полный доступ, управление
            сотрудниками и ролями, журнал аудита, удаление сущностей,
            производственный календарь.
          </li>
          <li>
            <b>Генеральный директор (ГД)</b> - полный обзор, утверждение
            запросов часов и сроков, закрытие проектов, форс-активация
            замещений.
          </li>
          <li>
            <b>Главный экономист (ГЭ)</b> - экономические реквизиты проектов,
            отчёт «Выручка по НЗП», настройки напоминаний о часах.
          </li>
          <li>
            <b>Бухгалтер (БУХ)</b> - экономические реквизиты проектов, отчёт
            «Выручка по НЗП».
          </li>
          <li>
            <b>Главный конструктор КБ (ГК)</b> - управление проектами и задачами
            своего КБ, назначение сотрудников своего КБ, утверждение отпусков
            своих подчинённых.
          </li>
          <li>
            <b>Руководитель отдела (РО)</b> - управление задачами своего отдела,
            согласование назначений подчинённых, утверждение отпусков.
          </li>
          <li>
            <b>Ответственный по проекту (ОП)</b> - управление задачами в своих
            проектах.
          </li>
          <li>
            <b>Менеджер проектов (МП)</b> - создание проектов и задач,
            управление вверенными проектами, назначение исполнителей без
            согласования.
          </li>
          <li>
            <b>HR-менеджер (HR)</b> - управление персоналом и отпусками,
            создание сотрудников.
          </li>
          <li>
            <b>Исполнитель (ИСП)</b> - работа с назначенными задачами. Роль
            присваивается автоматически при появлении задач и снимается, когда
            их не остаётся (если есть другие роли).
          </li>
        </ul>

        <h4>Особые правила</h4>
        <ul>
          <li>
            Роль «Исполнитель» - производная, её нельзя назначить вручную и
            нельзя делегировать.
          </li>
          <li>
            Роль «Руководитель отдела» действует только в тех подразделениях,
            где сотрудник числится.
          </li>
          <li>
            Главный конструктор КБ не имеет отдела - его основное место работы -
            КБ.
          </li>
          <li>
            Все роли, кроме «Исполнитель», делегируются через «Передачу
            полномочий».
          </li>
          <li>
            Заместитель получает эффективные роли на период замещения. Функции
            hasRole, getEffectiveRoles, getEffectiveKbIds,
            getEffectiveHeadDeptIds учитывают активные замещения.
          </li>
        </ul>

        <h4>Кто что может (краткая сводка)</h4>
        <ul>
          <li>
            Создавать задачи: admin, director, kb_chief, head, project_lead,
            project_manager.
          </li>
          <li>
            Создавать проекты: admin, director, kb_chief, project_manager.
          </li>
          <li>
            Назначать исполнителей без согласования: admin, director,
            project_manager, project_lead.
          </li>
          <li>
            Согласовывать назначения: руководители исполнителя, ГК КБ, директор,
            admin.
          </li>
          <li>Решать по запросам часов и сроков: director, admin.</li>
          <li>
            Смотреть экономику проекта: admin, director, economist, accountant.
          </li>
          <li>
            Смотреть отчёт «Выручка по НЗП»: admin, director, economist,
            accountant.
          </li>
          <li>Управлять производственным календарём: admin.</li>
          <li>Смотреть журнал аудита: admin, director.</li>
        </ul>
      </>
    ),
  },
  {
    id: "substitutions",
    label: "Замещения",
    content: (
      <>
        <h3>Замещения</h3>
        <p>
          Временная передача ролей и (опционально) задач коллеге на период
          отсутствия.
        </p>

        <h4>Создание</h4>
        <ol>
          <li>Личный кабинет → «Делегирование и замещение» → «Добавить».</li>
          <li>Режим «Замещение» (а не «Делегирование ролей»).</li>
          <li>Повод: отпуск, командировка, больничный, ротация, другое.</li>
          <li>Получатель - из списка доступных кандидатов.</li>
          <li>Роли - что передаём.</li>
          <li>Период - от даты до даты, либо «до отмены».</li>
          <li>
            Флажок «Передать задачи получателю» - при включении появляется выбор
            статусов.
          </li>
          <li>Кнопка «Отправить на согласование».</li>
        </ol>

        <h4>Активация</h4>
        <ul>
          <li>Получатель принимает - замещение становится активным.</li>
          <li>
            Если <code>start</code> уже наступил - замещение активируется
            автоматически при входе в систему или через интервальный sync.
          </li>
          <li>
            Admin/director могут «Применить сейчас», не дожидаясь решения
            получателя.
          </li>
        </ul>

        <h4>Что происходит с задачами</h4>
        <ul>
          <li>
            Задачи делегатора (по выбранным статусам) переназначаются
            получателю.
          </li>
          <li>
            У задачи сохраняется <code>delegatedFrom</code> и{" "}
            <code>delegatedByDelegationId</code> - для отката.
          </li>
          <li>В истории задачи появляется запись о переназначении.</li>
        </ul>

        <h4>Отзыв и завершение</h4>
        <ul>
          <li>Инициатор или admin/director отзывают активное замещение.</li>
          <li>
            Задачи возвращаются делегатору, если их не переназначили третьему
            лицу осознанно.
          </li>
          <li>
            Кэш <code>employee.substitutions</code> синхронизируется,
            эффективные роли снимаются.
          </li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Пересекающиеся замещения одного делегатора: возвращённые задачи
            подхватываются оставшимся активным замещением.
          </li>
          <li>
            Связь с отпуском - через правило: <code>kind === 'vacation'</code>,
            покрытие периода отпуска целиком, статус active/pending.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "vacations",
    label: "Отпуска",
    content: (
      <>
        <h3>Отпуска</h3>
        <p>
          Отпуск фиксирует факт отсутствия сотрудника. Замещение на период
          отпуска оформляется отдельно, вручную - отпуск и замещение не связаны
          жёстко.
        </p>

        <h4>Типы</h4>
        <ul>
          <li>Ежегодный.</li>
          <li>Административный.</li>
          <li>Больничный.</li>
          <li>Другой.</li>
        </ul>

        <h4>Статусы</h4>
        <ul>
          <li>На утверждении (pending).</li>
          <li>Утверждён (approved).</li>
          <li>Отклонён (rejected) - с обязательной причиной.</li>
        </ul>

        <h4>Кто может что</h4>
        <ul>
          <li>Сотрудник - создать и редактировать свой отпуск.</li>
          <li>HR - создавать и утверждать для любого сотрудника.</li>
          <li>Admin / director - то же плюс удаление.</li>
          <li>
            Руководитель отдела / ГК КБ - утверждать отпуска своих подчинённых.
          </li>
        </ul>

        <h4>Утверждение</h4>
        <p>
          Решение принимается в разделе «Запросы и заявки» → «Передача ролей и
          замещения» (или в диалоговом окне отпуска при наличии прав).
        </p>

        <h4>«Сотрудники в отпусках»</h4>
        <p>
          Кнопка в верхней панели открывает список тех, кто в отпуске сегодня:
          сотрудник, подразделение, даты, тип, комментарий, кто замещает.
        </p>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Отпуск нельзя создать, если он пересекается с уже утверждённым
            отпуском того же сотрудника.
          </li>
          <li>
            Признак отсутствия для напоминаний о часах:{" "}
            <code>status === 'approved'</code> и дата пересекает неделю, кроме
            командировок.
          </li>
          <li>
            Утверждённый начавшийся отпуск нельзя редактировать или удалять
            через карточку.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "budgets",
    label: "Бюджеты и планы",
    content: (
      <>
        <h3>Бюджеты и планы</h3>
        <p>Два уровня планирования - проект и задача.</p>

        <h4>Правила</h4>
        <ul>
          <li>
            <b>Проект</b>: сумма планов корневых задач ≤ план проекта.
          </li>
          <li>
            <b>Задача</b>: собственные факты (логи) + сумма планов всех потомков
            ≤ план узла.
          </li>
          <li>
            Правило работает на каждом уровне вверх - новая подзадача
            проверяется на всей цепочке.
          </li>
        </ul>

        <h4>Что происходит при нарушении</h4>
        <ul>
          <li>
            Сохранение блокируется с сообщением, в каком именно узле не хватает
            бюджета.
          </li>
          <li>Понижение плана проекта ниже суммы корневых задач невозможно.</li>
          <li>
            Уменьшение плана суммарной задачи ниже занятого (факт + планы
            подзадач) невозможно.
          </li>
        </ul>

        <h4>Отчёты</h4>
        <ul>
          <li>
            Нарушения по задачам - метод <code>getBudgetViolations</code>.
          </li>
          <li>
            Нарушения по проектам - метод{" "}
            <code>getProjectBudgetViolations</code>.
          </li>
          <li>
            Автоподъём плана - метод <code>fixBudgetViolations</code>{" "}
            (применяется администратором).
          </li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>Административные проекты без плана в проверках не участвуют.</li>
          <li>Архивные сущности в отчётах о нарушениях не участвуют.</li>
          <li>
            Правило распространяется на все планы задачи, включая промежуточные
            - «конверт должен влезать в конверт».
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "dependencies",
    label: "Зависимости задач",
    content: (
      <>
        <h3>Зависимости задач</h3>
        <p>
          Зависимость фиксирует одно поле последователя от одного поля
          предшественника.
        </p>

        <h4>Типы</h4>
        <ul>
          <li>
            <b>FS</b> (Окончание-Начало): B.start = A.deadline + 1.
          </li>
          <li>
            <b>SS</b> (Начало-Начало): B.start = A.start.
          </li>
          <li>
            <b>FF</b> (Окончание-Окончание): B.deadline = A.deadline.
          </li>
        </ul>

        <h4>Что это даёт</h4>
        <ul>
          <li>
            При изменении предшественника последователи автоматически
            сдвигаются.
          </li>
          <li>
            Сдвиг распространяется по цепочке - если A повлиял на B, а B на C,
            сдвиг дойдёт и до C.
          </li>
          <li>
            Заблокированное поле в форме задачи нельзя редактировать руками.
          </li>
        </ul>

        <h4>Ограничения</h4>
        <ul>
          <li>У задачи может быть только один предшественник.</li>
          <li>
            Задача с зависимостью не перетаскивается в диаграмме Ганта - сначала
            уберите зависимость.
          </li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Если у предшественника нет нужной даты, заблокированное поле не
            перезаписывается.
          </li>
          <li>
            Циклы в цепочке предотвращаются - повторный сдвиг уже сдвинутой
            задачи не выполняется.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "audit",
    label: "Аудит и история",
    content: (
      <>
        <h3>Аудит и история</h3>
        <p>
          В системе две параллельные хроники. Это разные журналы, у них разное
          назначение.
        </p>

        <h4>Журнал аудита</h4>
        <ul>
          <li>Глобальный журнал действий по всем сущностям.</li>
          <li>
            Формат - объект «{`{Поле: было → стало}`}» для внешнего наблюдателя.
          </li>
          <li>Видят только admin и director.</li>
          <li>Раздел - «Журнал аудита».</li>
        </ul>

        <h4>История сущности (вкладка «История»)</h4>
        <ul>
          <li>Локальная хроника по конкретной задаче или проекту.</li>
          <li>
            Формат - плоский список строк «Метка: было → стало» и текстовых
            событий.
          </li>
          <li>Видна всем, у кого есть доступ к сущности.</li>
        </ul>

        <h4>Что фиксируется в аудите</h4>
        <ul>
          <li>Создание, изменение, удаление, восстановление сущностей.</li>
          <li>
            Изменения полей - название, даты, план, статус, приоритет,
            исполнитель, ответственный, метки.
          </li>
          <li>Внесение и правки часов.</li>
          <li>Заявки на согласование и решения по ним.</li>
          <li>Утверждение/отклонение отпусков.</li>
          <li>Решения по замещениям.</li>
          <li>
            Автоматические действия (архивация задач, автоподъём плана, отправка
            напоминаний).
          </li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>Аудит неизменяем - записи только добавляются.</li>
          <li>
            История сущности может расширяться при каждом сохранении
            задачи/проекта.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "export",
    label: "Экспорт CSV",
    content: (
      <>
        <h3>Экспорт в CSV</h3>
        <p>
          Экспорт доступен в отчётах, в личном кабинете (свои часы), в журнале
          аудита.
        </p>

        <h4>Технические детали</h4>
        <ul>
          <li>
            Файл в кодировке UTF-8 с BOM - открывается в Excel и LibreOffice без
            плясок с кодировкой.
          </li>
          <li>Разделитель - «;».</li>
          <li>
            Все ячейки в двойных кавычках; внутренние кавычки удваиваются.
          </li>
          <li>
            Формулы обезврежены: если значение начинается с «=», «+», «-», «@»,
            перед ним ставится апостроф.
          </li>
        </ul>

        <h4>Имя файла</h4>
        <p>
          Собирается автоматически. Запрещённые в именах символы (
          <code>\ / : * ? " &lt; &gt; |</code>) заменяются на «_».
        </p>

        <h4>Особые случаи</h4>
        <ul>
          <li>
            Пустой результат - всплывающее уведомление «Нет данных для
            выгрузки», файл не создаётся.
          </li>
          <li>
            Числа выводятся как есть, без разделителей разрядов и символа
            валюты.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "theme",
    label: "Тема оформления",
    content: (
      <>
        <h3>Тема оформления</h3>
        <p>
          В верхней панели - иконка солнца/луны. Нажатие переключает светлую и
          тёмную темы.
        </p>

        <h4>Как это работает</h4>
        <ul>
          <li>
            Тема хранится в localStorage под ключом <code>ui.theme</code>.
          </li>
          <li>
            При первом входе тема подбирается по системной настройке (
            <code>prefers-color-scheme</code>).
          </li>
          <li>
            После явного выбора темы система больше не подстраивается под
            системную.
          </li>
        </ul>

        <h4>Особые случаи</h4>
        <ul>
          <li>Смена темы не влияет на данные и не перезагружает страницу.</li>
          <li>Тема сохраняется между перезагрузками.</li>
        </ul>
      </>
    ),
  },
  {
    id: "hotkeys",
    label: "Горячие клавиши",
    content: (
      <>
        <h3>Горячие клавиши и приёмы</h3>

        <h4>Enter в диалоговом окне</h4>
        <ul>
          <li>Enter в поле ввода = «Сохранить».</li>
          <li>
            В textarea Enter = перенос строки (диалоговое окно не сохраняется).
          </li>
          <li>
            В флажке / радиокнопке / поле выбора файла Enter не перехватывается.
          </li>
          <li>
            В поле внутри вложенной <code>&lt;form&gt;</code> Enter запускает
            submit формы, а не диалоговое окно.
          </li>
        </ul>

        <h4>Поле ввода комментария</h4>
        <ul>
          <li>Enter - отправить сообщение.</li>
          <li>Ctrl/Cmd + Enter - перенос строки.</li>
        </ul>

        <h4>Escape</h4>
        <ul>
          <li>
            Закрывает верхний слой: диалоговое окно, выпадающий список, меню
            «⋯», просмотрщик изображений.
          </li>
          <li>Если открыто несколько слоёв - закрывается только верхний.</li>
          <li>
            Во время перетаскивания в диаграмме Ганта - отменяет перетаскивание.
          </li>
        </ul>

        <h4>Нажатие вне</h4>
        <ul>
          <li>Нажатие по затемнению диалогового окна (вне окна) - закрытие.</li>
          <li>Нажатие вне выпадающего списка или меню - закрытие.</li>
        </ul>

        <h4>Поиск в чате</h4>
        <ul>
          <li>
            Стрелки вверх/вниз в панели поиска перемещают между совпадениями.
          </li>
          <li>Каждое совпадение подсвечивается и прокручивается к центру.</li>
        </ul>

        <h4>Загрузка файлов</h4>
        <ul>
          <li>Перетаскивание файлов на область загрузки.</li>
          <li>Нажатие на «Загрузить файлы» - выбор через системный диалог.</li>
          <li>Множественный выбор поддерживается.</li>
        </ul>
      </>
    ),
  },
  {
    id: "faq",
    label: "Частые вопросы",
    content: (
      <>
        <h3>Частые вопросы</h3>

        <h4>Почему я не вижу чужую задачу?</h4>
        <p>
          Видимость задач определяется ролями, КБ, отделами и явным доступом к
          проекту. Проверьте свои роли и подразделения в личном кабинете.
        </p>

        <h4>Почему задача не появляется на доске задач?</h4>
        <p>
          Возможно, она в черновике (<code>status: draft</code>) - такие задачи
          живут только в разделе «Черновики» и видны только создателю. Или
          задача уже архивирована - тогда она в «Архиве».
        </p>

        <h4>Почему не могу сдать часы?</h4>
        <p>
          Проверьте: дата не в будущем, не раньше начала задачи, не позже срока.
          На эту дату ещё нет записи. Часы не превышают остатка плана задачи.
        </p>

        <h4>Как передать роли на время отпуска?</h4>
        <p>
          Личный кабинет → «Делегирование и замещение» → «Добавить», режим
          «Замещение». Выберите получателя, роли, период. Получатель должен
          принять - после этого роли и задачи перейдут к нему.
        </p>

        <h4>Что означает значок «N ст.»?</h4>
        <p>
          Это эффективная ставка сотрудника. 1 ст. - полная занятость, 0.5 ст. -
          половина. Влияет на расчёт ёмкости в разделе «Загрузка» и на
          напоминания о часах.
        </p>

        <h4>Как вернуть уволенного сотрудника?</h4>
        <p>
          «Персонал» → секция «Архив сотрудников» → «Показать» → кнопка
          «Восстановить» в строке сотрудника.
        </p>

        <h4>Почему проект не виден другим?</h4>
        <p>
          По умолчанию проект виден по ролям, КБ и задачам. Чтобы явно открыть
          проект сотруднику, используйте кнопку «Доступ» в футере карточки
          проекта.
        </p>

        <h4>Как получить отчёт по своим часам?</h4>
        <p>
          Личный кабинет → вкладка «Сводка» → поля «Экспорт» → выберите период →
          «Выгрузить в Excel (CSV)».
        </p>

        <h4>Кто видит мои черновики?</h4>
        <p>
          Только вы, пока черновик не ушёл на согласование. После отправки
          согласующий (руководитель исполнителя) видит заявку в разделе «Запросы
          и заявки».
        </p>

        <h4>Как добавить год в производственный календарь?</h4>
        <p>
          Личный кабинет (только для админа) → «Правка календаря» → «Сегодня»
          создаст текущий год, либо удалите старый и создайте новый.
        </p>

        <h4>Почему задача без дедлайна не видна в календаре?</h4>
        <p>
          Календарь отображает задачи по полю «Срок исполнения». Без срока
          задача не попадает ни в один день.
        </p>

        <h4>Как часто приходят напоминания о часах?</h4>
        <p>
          По расписанию: день недели + час МСК, заданные в личном кабинете (для
          admin/director/economist). Есть cooldown 6 суток. Кнопка «Отправить
          сейчас» рассылает в обход расписания.
        </p>

        <h4>Что будет, если согласующий отклонит назначение?</h4>
        <p>
          Объект вернётся в черновики автору, поле исполнителя очистится. Автор
          получит уведомление со ссылкой и сможет выбрать другого исполнителя
          или отправить заново.
        </p>

        <h4>Как скопировать проект или задачу?</h4>
        <p>
          В карточке - кнопка «Копировать». Откроется форма нового объекта с
          заполненными полями. ID, ответственный, экономика сбрасываются.
        </p>

        <h4>Как найти все задачи с одной меткой?</h4>
        <p>
          Нажатие на ярлык метки - где бы он ни был: в карточке задачи или
          проекта, в списке, на доске задач - открывает список всех задач и
          проектов с этой меткой. Другой способ - выпадающий список «Метка» в
          панели фильтров разделов «Задачи» или «Проекты».
        </p>
      </>
    ),
  },
];
